module.exports = __webpack_public_path__ + "static/media/falcon9.be50af34.png";